export const MENU_BUTTON_EXPANDABLE = 'menu-button-expandable';
